import { defineMessages } from 'react-intl';

export default defineMessages({
  location: {
    id: 'common.titles.location',
    defaultMessage: 'Location',
  },
  language: {
    id: 'common.titles.language',
    defaultMessage: 'Language',
  },
  confirmButton: {
    id: 'common.buttons.confirm',
    defaultMessage: 'Confirm',
  },
});
